export const FETCH_DRIVERPROF_ACTION = "FETCH_DRIVERPROF_ACTION";
export const FETCH_DRIVERPROF_FAIL_ACTION = FETCH_DRIVERPROF_ACTION + "_ERROR";
export const FETCH_DRIVERPROF_SUCCESS_ACTION =
  FETCH_DRIVERPROF_ACTION + "_SUCCESS";

export const DELETE_USER_INIT_ACTION = "DELETE_USER_INIT_ACTION";
export const DELETE_USER_SUCCESS_ACTION = DELETE_USER_INIT_ACTION + "_SUCCESS";
export const DELETE_USER_FAIL_ACTION = DELETE_USER_INIT_ACTION + "_ERROR";

export const FETCH_DRIVERBYID_ACTION = "FETCH_DRIVERBYID_ACTION";
export const FETCH_DRIVERBYID_FAIL_ACTION = FETCH_DRIVERBYID_ACTION + "_ERROR";
export const FETCH_DRIVERBYID_SUCCESS_ACTION =
  FETCH_DRIVERBYID_ACTION + "_SUCCESS";

export const FETCH_OPENDRIVER_ACTION = "FETCH_OPENDRIVER_ACTION";
export const FETCH_OPENDRIVER_FAIL_ACTION = FETCH_OPENDRIVER_ACTION + "_ERROR";
export const FETCH_OPENDRIVER_SUCCESS_ACTION =
  FETCH_OPENDRIVER_ACTION + "_SUCCESS";

export const ATTACH_DRIVER_ACTION = "ATTACH_DRIVER_ACTION";
export const ATTACH_DRIVER_FAIL_ACTION = ATTACH_DRIVER_ACTION + "_ERROR";
export const ATTACH_DRIVER_SUCCESS_ACTION = ATTACH_DRIVER_ACTION + "_SUCCESS";

export const UPDATE_USERPROF_ACTION = "UPDATE_USERPROF_ACTION";
export const UPDATE_USERPROF_FAIL_ACTION = UPDATE_USERPROF_ACTION + "_ERROR";
export const UPDATE_USERPROF_SUCCESS_ACTION =
  UPDATE_USERPROF_ACTION + "_SUCCESS";

export const DETTACH_DRIVER_ACTION = "DETTACH_DRIVER_ACTION";
export const DETTACH_DRIVER_FAIL_ACTION = DETTACH_DRIVER_ACTION + "_ERROR";
export const DETTACH_DRIVER_SUCCESS_ACTION = DETTACH_DRIVER_ACTION + "_SUCCESS";

export const DELETE_DRIVERLIST_ACTION = 'DELETE_DRIVERLIST_ACTION';

export function fetchdriverprof(params) {
 
  return {
    type: FETCH_DRIVERPROF_ACTION,
    params: params,
  };
}
export function deleteuser(value) {
 
  return {
    type: DELETE_USER_INIT_ACTION,
    value: value,
  };
}
export function fetchdriverById(item) {
  
  return {
    type: FETCH_DRIVERBYID_ACTION,
    item: item,
  };
}
export function fetchopendrivers(params) {
 
  return {
    type: FETCH_OPENDRIVER_ACTION,
    params: params,
  };
}

export function attachDriver(value) {
  
  return {
    type: ATTACH_DRIVER_ACTION,
    value: value,
  };
}
export function dettachDriver(value) {
  
  return {
    type: DETTACH_DRIVER_ACTION,
    value: value,
  };
}

export function deleteDrvrList() {
  return {
    type: DELETE_DRIVERLIST_ACTION,
  };
}
